export default __webpack_public_path__ + "static/media/activeDarkBlueMarker.959f95d8.svg";